import { useContext } from 'react';
import { TabContext } from './TabContext.js';
import styles from './Tabs.module.scss.js';
import { jsx } from 'react/jsx-runtime';
import { MenuItem } from '../menu/ItemTreeNodes/MenuItem.js';
import { Button } from '../button/Button.js';
import classNames from 'clsx';

function Tab(props) {
  const {
    id,
    disabled,
    children,
    className: callerClassName,
    tag = id
  } = props;
  const {
    menu,
    selected,
    variant,
    size,
    onSelect
  } = useContext(TabContext);
  const isSelected = id === selected;
  const className = classNames('dsx-component', styles['tab'], isSelected && styles['selected'], callerClassName);
  function handleClick() {
    if (!disabled) {
      onSelect(id);
    }
  }
  const buttonVariant = {
    default: 'ui-control',
    inverse: 'inverse-ui-control'
  }[variant];
  return menu ? /*#__PURE__*/jsx(MenuItem, {
    disabled: disabled,
    value: id,
    children: children
  }) : /*#__PURE__*/jsx(Button, {
    "aria-selected": isSelected,
    className: className,
    disabled: disabled,
    role: "tab",
    size: size,
    variant: buttonVariant,
    "data-dsx--tab": tag,
    onClick: handleClick,
    children: children
  });
}

export { Tab };
